import {CounterLabel, Label, UnderlineNav} from '@primer/react'
import {ActionabilityBannerWrapper} from './ActionabilityBanner'
import {CondensedMergeStatus} from './CondensedMergeStatus'
import {Reviewers} from './Reviewers'
import {SidebarSection} from './SidebarSection'
import styles from './Sidebar.module.css'

/** Full Overview sidebar panel */
export function OverviewPanel() {
  return (
    <div className={styles.sidebar}>
      <UnderlineNav aria-label="Sidebar tabs">
        <UnderlineNav.Item aria-current="page">Info</UnderlineNav.Item>
        <UnderlineNav.Item>
          Comments <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>
          Findings <CounterLabel>NN</CounterLabel>
        </UnderlineNav.Item>
        <UnderlineNav.Item>Agents</UnderlineNav.Item>
      </UnderlineNav>

      <ActionabilityBannerWrapper />
      <CondensedMergeStatus />

      <Reviewers />

      <SidebarSection title="Assignees">
        <div className={styles.assigneeRow}>
          <span className={styles.avatar} />
          <span className={styles.assigneeName}>karpathy</span>
        </div>
      </SidebarSection>

      <SidebarSection title="Labels">
        <div className={styles.labelRow}>
          <Label>ui-components</Label>
          <Label>size/L</Label>
        </div>
      </SidebarSection>

      <SidebarSection title="Deployments" actions={['expand']}>
        <div className={styles.deploymentRow}>
          <span className={styles.avatar} />
          <span className={styles.deploymentName}>Storybook</span>
        </div>
      </SidebarSection>

      <SidebarSection title="Projects" actions={['add']} />
      <SidebarSection title="Milestone" />
    </div>
  )
}
